import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Briefcase, Users2, Landmark, Shield, Crown } from 'lucide-react';
export function Solutions() {
  const applications = [{
    icon: <GraduationCap size={24} data-id="element-1687" data-mp="2lza6orrv942z" />,
    title: 'Education',
    desc: 'Develop reasoning, self-direction, media literacy, and long-term capability from childhood through university.'
  }, {
    icon: <Briefcase size={24} data-id="element-1688" data-mp="2d0opp121lx4b" />,
    title: 'Employers',
    desc: 'Improve execution, communication, decision quality, and leadership development.'
  }, {
    icon: <Users2 size={24} data-id="element-1689" data-mp="239kbi3k6ygaj" />,
    title: 'Civil Society',
    desc: 'Strengthen mentorship systems, local resilience, and opportunity alignment.'
  }, {
    icon: <Landmark size={24} data-id="element-1690" data-mp="1y8o074xifrv3" />,
    title: 'Government',
    desc: 'Support workforce modernization, civic capability planning, and public-sector development.'
  }, {
    icon: <Shield size={24} data-id="element-1691" data-mp="1pakof0cbu9gh" />,
    title: 'Civil Service',
    desc: 'Improve integrity, stability, systems reasoning, and readiness for responsibility.'
  }, {
    icon: <Crown size={24} data-id="element-1692" data-mp="1f9ulhn6iz3wn" />,
    title: 'Leadership Development',
    desc: 'Move beyond charisma toward stress-tested competence and consequence reasoning.'
  }];
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-surface-bg" id="solutions" data-id="element-1693" data-mp="15ihsutcwk9pk">
      <div className="mb-16" data-id="element-1694" data-mp="1t9vmd2msibc4">
        <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-4 block" data-id="element-1695" data-mp="1t6hitr2e3w33">
          Applications
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-1696" data-mp="1k85slq5fr0b6">
          Built for individuals, institutions, and nations
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1697" data-mp="1p93bk4y9rydq">
        {applications.map((app, index) => <motion.div key={app.title} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-white p-8 rounded-lg border border-line shadow-sm hover:shadow-md transition-all group" data-id="element-1698" data-mp="drk3nz9qv78u" data-mpi={index}>
            <div className="w-12 h-12 rounded-md bg-surface-muted flex items-center justify-center text-navy-light mb-6 group-hover:bg-navy group-hover:text-white transition-colors" data-id="element-1699" data-mp="1ws2vcbpn7rxm">
              {app.icon}
            </div>
            <h3 className="text-xl font-heading font-bold text-ink-dark mb-3" data-id="element-1700" data-mp="1mu57vqflxz62">
              {app.title}
            </h3>
            <p className="text-ink-muted leading-relaxed" data-id="element-1701" data-mp="3h636kygajcnp">{app.desc}</p>
          </motion.div>)}
      </div>
    </section>;
}